import axios from 'axios';

import { configureHttpHeaders, onSuccess, onError, onErrorUnmatched } from './apiHelpers';
import { getQueueManagerBaseUrl } from './queueManagerBaseUrl.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';

const QUEUE_MANAGER_DATA_API = getQueueManagerBaseUrl();

export function getMyQueues() {
  configureHttpHeaders(axios);
  return get('api/v1/queuemanager/queues/myqueues/cases/count');
}

export function getUnresovedRTIdata(
  regionCode,
  queueId,
  userId,
  pageNumber,
  size,
  sort,
  queueSearchView,
  acquirerAccessCode,
) {
  let url = 'api/v2/queuemanager/queues/unresolve/action';
  let sortKeyString = [];
  let sortOrderString = [];
  sort.forEach((element) => {
    sortKeyString.push(element.key);
    sortOrderString.push(element.order ? 'ASC' : 'DESC');
  });

  let data = {
    acquirerAccessCode: typeof acquirerAccessCode === 'string' ? [acquirerAccessCode] : acquirerAccessCode,
    orderByProperties: sortKeyString,
    pageNumber: pageNumber,
    propertyDirections: sortOrderString,
    queueId: queueId,
    queueSearchView: queueSearchView,
    regionCode: regionCode,
    size: size,
    userId: userId,
  };

  configureHttpHeaders(axios);

  return post(url, data);
}

export function getCategoryLabels() {
  configureHttpHeaders(axios);
  return get(`api/v2/queuemanager/queue/category`);
}

export function getQueueLabels(fetchAllFlag) {
  configureHttpHeaders(axios);
  return get(`api/v2/queuemanager/categorymaster?fetchAll=${fetchAllFlag}`);
}

export function getDefaultQueueList(regionCode, queueId, acquirerAccessCode) {
  configureHttpHeaders(axios);
  return get(
    `api/v1/queuemanager/queues/default/region/cases/count?regionCode=${regionCode}&acquirerAccessCode=${acquirerAccessCode}`,
  );
}

export function getQueueSummary(
  queueGroupCode,
  actionCategoryCode,
  userId,
  queueId,
  queueSearchView,
  pinDebitAcquirerCodes,
) {
  configureHttpHeaders(axios);

  let data = {
    acquirerAccessCode: null,
    orderByProperties: null,
    pageNumber: 0,
    propertyDirections: null,
    queueId: parseInt(queueId),
    queueSearchView: queueSearchView,
    regionCode: null,
    size: 25,
    userId: userId,
  };

  let url = `api/v2/queuemanager/queue/header/count?queueGroupCode=${queueGroupCode}&actionCategoryCode=${actionCategoryCode}`;
  if (pinDebitAcquirerCodes && pinDebitAcquirerCodes.length > 0) {
    url = url + `&acquirerCodes=${pinDebitAcquirerCodes}`;
  }
  if (userId) {
    url = url + `&userId=${userId}`;
  }
  return post(url, data);
}

export function getSubQueueList(actionCategoryCode, queueGroupCode, isVisible) {
  let url = `api/v2/queuemanager/subqueues?actionCategoryCode=${actionCategoryCode}&queueGroupCode=${queueGroupCode}`;
  if (!!isVisible) {
    url = url + `&isVisible=${isVisible}`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

export function getQueueGroupList(acquirerAccess, userId) {
  configureHttpHeaders(axios);
  return get(`api/v2/queuemanager/queue/group?acquirerCodes=${acquirerAccess}&userId=${userId}`);
}

export function getBaseQueueGroupList(acquirerAccess) {
  configureHttpHeaders(axios);
  return get(`api/v2/queuemanager/basequeues?acquirerCodes=${acquirerAccess}`);
}

export function getExcepionList(queueGroupCode, acquirerAccessList) {
  configureHttpHeaders(axios);
  return get(`api/v2/queuemanager/exceptions?queueGroupCode=${queueGroupCode}&acquirerCodes=${acquirerAccessList}`);
}

export function getSubQueueGroupList(acquirerAccess, subCatagoryCodes) {
  configureHttpHeaders(axios);
  return get(`api/v2/queuemanager/subqueues/list?acquirerCodes=${acquirerAccess}&subCategoryCode=${subCatagoryCodes}`);
}

export function getAllQueueList() {
  configureHttpHeaders(axios);
  return get(`api/v1/queuemanager/queues/all/cases/count`);
}

export function unAssignCase(unassignmentData) {
  //TODO: this details needed from API
  configureHttpHeaders(axios);
  return post(`api/v1/queuemanager/case/unassign`, unassignmentData);
}

export function assignCase(assignmentData) {
  //TODO: this details needed from API
  configureHttpHeaders(axios);

  return post(`api/v1/queuemanager/case/assign`, assignmentData);
}

export function bulkAssignment(assignmentData) {
  //TODO: this details needed from API
  configureHttpHeaders(axios);
  return post(`api/v1/queuemanager/case/assign/bulk`, assignmentData);
}

export function assignCasesToGroup(assignmentData) {
  //TODO: this details needed from API
  configureHttpHeaders(axios);
  return post(`api/v1/queuemanager/case/assign/region`, assignmentData);
}

export function getExceptionQueue(acquirerAccessList) {
  let url;
  if (!!acquirerAccessList) {
    url = `api/v1/queuemanager/queues/exception/cases/count?acquirerList=${acquirerAccessList}`;
  } else {
    url = `api/v1/queuemanager/queues/exception/cases/count`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

// This is used to get general queues case count
export function getGeneralQueuesSummary(acquirerAccessList) {
  configureHttpHeaders(axios);
  return get(`api/v1/queuemanager/queues/general/cases/count?acquirerAccessCode=${acquirerAccessList}`);
}
// This is used to get assigned queues case count
export function getAssignedQueuesSummary(acquirerAccessList) {
  configureHttpHeaders(axios);
  return get(`api/v1/queuemanager/users/cases/count?acquirerAccessCode=${acquirerAccessList}`);
}
// This is used to get user specific case count
export function getAssignedCasesHeaderData(userId) {
  configureHttpHeaders(axios);
  return get(`api/v1/queuemanager/queues/general/cases/count?userId=${userId}`);
}

// This is used to get reason code specific case count
export function getRegionCodeHeaderData(regionCode, queueId, acquirerAccessList) {
  configureHttpHeaders(axios);
  return get(
    `api/v1/queuemanager/queues/general/cases/count?merchantRegionCode=${regionCode}&queueId=${queueId}&acquirerAccessCode=${acquirerAccessList}`,
  );
}

export function getUserGroups(acquirerAccessList) {
  configureHttpHeaders(axios);
  return get(`api/v1/queuemanager/groups?acquirerList=${acquirerAccessList}`);
}

export function getGroupAnalystDetails(userGroupId, acquirer) {
  let url;
  if (userGroupId === null || userGroupId === undefined) {
    url = `api/v1/queuemanager/groups/users/cases/count?acquirerList=${acquirer}`;
  } else {
    url = `api/v1/queuemanager/groups/users/cases/count?userGroupId=${userGroupId}&acquirerList=${acquirer}`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

export function getAllAnalystDetails() {
  const url = 'api/v1/queuemanager/groups/users';
  configureHttpHeaders(axios);
  return get(url);
}

export function getGroupCasesCount(userGroupId, acquirer) {
  let url;
  if (userGroupId === null || userGroupId === undefined) {
    url = `api/v1/queuemanager/users/cases/count?acquirerAccessCode=${acquirer}`;
  } else {
    url = `api/v1/queuemanager/users/cases/count?userGroupId=${userGroupId}&acquirerAccessCode=${acquirer}`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

export function getDataForQueueMgmtLanding(
  regionCode,
  queueId,
  userId,
  pageNumber,
  size,
  sort,
  queueSearchView,
  acquirerAccessCode,
) {
  let param;
  let sortKeyString = [];
  let sortOrderString = [];
  sort.forEach((element) => {
    sortKeyString.push(element.key);
    sortOrderString.push(element.order ? 'ASC' : 'DESC');
  });

  let data = {
    orderByProperties: sortKeyString,
    pageNumber: pageNumber,
    propertyDirections: sortOrderString,
    size: size,
    queueSearchView: queueSearchView,
  };

  if (userId) {
    param = `userId=${userId}`;
    data['userId'] = userId;
  } else if (regionCode !== undefined && regionCode !== null && regionCode !== '' && queueId !== undefined) {
    param = `regionCode=${regionCode}&queueId=${queueId}`;
    data['regionCode'] = regionCode;
    data['queueId'] = queueId;
  }
  data['acquirerAccessCode'] = acquirerAccessCode;
  data['acquirerCodes'] = getAcquirerAccessList();
  if (queueId === 69 || queueId === 70) {
    // eslint-disable-next-line no-unused-vars
    param = `queueId=${queueId}`;
    data['queueId'] = queueId;
  }

  //const url = `api/v1/queuemanager/queues/region/users/cases?${param}&pageNumber=${pageNumber}&size=${size}&propertyDirections=${(sort.order) ? 'ASC' : 'DESC'}&orderByProperties=${sort.key}`;
  configureHttpHeaders(axios);
  return post('api/v1/queuemanager/queues/region/users/cases', data);
}

export function getDataForDynamicQueueLanding(
  regionCode,
  queueId,
  userId,
  pageNumber,
  size,
  sort,
  queueSearchView,
  acquirerAccessCode,
  searchType,
  pinDebitAcquirerCodes,
) {
  let sortKeyString = [];
  let sortOrderString = [];
  sort.forEach((element) => {
    sortKeyString.push(element.key);
    sortOrderString.push(element.order ? 'ASC' : 'DESC');
  });

  let data = {
    acquirerAccessCode: acquirerAccessCode,
    orderByProperties: sortKeyString,
    pageNumber: pageNumber,
    propertyDirections: sortOrderString,
    queueId: queueId,
    queueSearchView: queueSearchView,
    regionCode: regionCode,
    size: size,
    userId: userId,
  };

  let url = `api/v2/queuemanager/queues/region/users/cases`;
  if (searchType) {
    url = url + `?searchType=${searchType}`;
  }
  if (pinDebitAcquirerCodes && pinDebitAcquirerCodes.length > 0) {
    url = url + `&acquirerCodes=${pinDebitAcquirerCodes}`;
  }

  configureHttpHeaders(axios);
  return post(url, data);
}

export function postBookMarkCase(caseStageId) {
  configureHttpHeaders(axios);
  return postBase(`api/v1/queuemanager/users/bookmarks/cases?caseStageId=${caseStageId}`);
}

export function undoBookMarkCase(caseStageId) {
  configureHttpHeaders(axios);
  return deleteUrl(QUEUE_MANAGER_DATA_API, `api/v1/queuemanager/users/bookmarks/cases?caseStageId=${caseStageId}`);
}
export function getBookMarkedCases() {
  configureHttpHeaders(axios);
  return get(`api/v1/queuemanager/users/bookmarks/cases`);
}

export function getAssignedCasesCount() {
  configureHttpHeaders(axios);
  return get('api/v1/queuemanager/queues/all/cases/count?queueType=ASSIGNED_CASES');
}

export function getExceptionCasesCount(acquirerAccessList) {
  let url;
  if (!!acquirerAccessList) {
    url = `api/v1/queuemanager/queues/all/cases/count?queueType=EXCEPTION_QUEUE&acquirerList=${acquirerAccessList}`;
  } else {
    url = `api/v1/queuemanager/queues/all/cases/count?queueType=EXCEPTION_QUEUE`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

export function getMerchantMatchedFailCasesCount(acquirerAccessList) {
  let url;
  if (!!acquirerAccessList) {
    url = `api/v1/queuemanager/queues/all/cases/count?queueType=MERCHANT_MATCH_FAILED&acquirerList=${acquirerAccessList}`;
  } else {
    url = `api/v1/queuemanager/queues/all/cases/count?queueType=MERCHANT_MATCH_FAILED`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

export function getDefaultQueueCasesCount(acquirerAccessList) {
  let url;
  if (!!acquirerAccessList) {
    url = `api/v1/queuemanager/queues/all/cases/count?queueType=DEFAULT_QUEUE_WITH_REGION&acquirerList=${acquirerAccessList}`;
  } else {
    url = `api/v1/queuemanager/queues/all/cases/count?queueType=DEFAULT_QUEUE_WITH_REGION`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

export function getMexicoQueueCount() {
  configureHttpHeaders(axios);
  return get('api/v1/queuemanager/queues/all/cases/count?queueType=MEXICO_QUEUE_COUNT');
}

export function getMerchantImageAllRegionCount(acquirerAccessList) {
  configureHttpHeaders(axios);
  if (!!acquirerAccessList) {
    return get(`api/v1/queuemanager/queues/all/cases/count?queueType=MERCHANT_IMAGE_ALL_REGION&acquirerList=${acquirerAccessList}`);
  }
  return get('api/v1/queuemanager/queues/all/cases/count?queueType=MERCHANT_IMAGE_ALL_REGION');
}

export function getSchemeExceptionCasesCount(acquirerAccessList) {
  let url;
  if (!!acquirerAccessList) {
    url = `api/v1/queuemanager/queues/all/cases/count?queueType=SCHEME_EXCEPTION&acquirerList=${acquirerAccessList}`;
  } else {
    url = `api/v1/queuemanager/queues/all/cases/count?queueType=SCHEME_EXCEPTION`;
  }
  configureHttpHeaders(axios);
  return get(url);
}

export function getAmexOp1CasesCount() {
  configureHttpHeaders(axios);
  return get('api/v1/queuemanager/queues/all/cases/count?queueType=AMEX_OP1_CASES');
}

export function postUpdateQueueFilters(filterTypeId, activeFilters, customQueueId) {
  const url = `api/v2/queuemanager/updateQueue?customQueueId=${customQueueId}`;
  const data = {
    filterId: filterTypeId,
    savedFilterElements: activeFilters,
  };
  configureHttpHeaders(axios);
  return postUnmatched(url, data);
}

export function postCreateQueueFilters(filterTypeId, activeFilters) {
  const url = `api/v2/queuemanager/filters/save`;
  const data = {
    filterId: filterTypeId,
    savedFilterElements: activeFilters,
  };
  configureHttpHeaders(axios);
  return postUnmatched(url, data);
}

export function deleteSubQueue(customQueueID) {
  configureHttpHeaders(axios);
  return post(`api/v2/queuemanager/queue/delete?customQueueID=${customQueueID}`);
}

export function getNextCasesOfSubQueue(customQueueID, userId, caseNumber) {
  configureHttpHeaders(axios);
  if (!!caseNumber) {
    return get(
      `api/v2/queuemanager/getnext/nextcase?customQueueId=${customQueueID}&userId=${userId}&caseNumber=${caseNumber}`,
    );
  }
  return get(`api/v2/queuemanager/getnext/nextcase?customQueueId=${customQueueID}&userId=${userId}`);
}

export function unLockGetNextCases(userId) {
  configureHttpHeaders(axios);
  return deleteUrl(QUEUE_MANAGER_DATA_API, `api/v2/queuemanager/getnext/cases/unlock?userId=${userId}`);
}

export function updateQueueVisibility(queueId, visibilityInd) {
  configureHttpHeaders(axios);
  return postUnmatched(
    `api/v2/queuemanager/queue/updateEnableDisable?customQueueId=${queueId}&isEnableQueue=${visibilityInd}`,
  );
}

export function getWexCasesCount() {
  configureHttpHeaders(axios);
  return get('api/v1/queuemanager/queues/all/cases/count?queueType=WEX_CASES');
}

function get(url) {
  return axios.get(`${QUEUE_MANAGER_DATA_API}${url}`).then(onSuccess).catch(onError);
}

function getUnmatched(url) {
  return axios.get(`${QUEUE_MANAGER_DATA_API}${url}`).then(onSuccess).catch(onErrorUnmatched);
}

function post(relativeURL, responseBody) {
  return axios({
    method: 'post',
    url: `${QUEUE_MANAGER_DATA_API}${relativeURL}`,
    data: responseBody,
  })
    .then(onSuccess)
    .catch(onError);
}

function put(relativeURL, responseBody) {
  return axios({
    method: 'put',
    url: `${QUEUE_MANAGER_DATA_API}${relativeURL}`,
    data: responseBody,
  })
    .then(onSuccess)
    .catch(onError);
}

function postUnmatched(relativeURL, responseBody) {
  return axios({
    method: 'post',
    url: `${QUEUE_MANAGER_DATA_API}${relativeURL}`,
    data: responseBody,
  })
    .then(onSuccess)
    .catch(onErrorUnmatched);
}

function postBase(relativeURL) {
  return axios({
    method: 'post',
    url: `${QUEUE_MANAGER_DATA_API}${relativeURL}`,
  })
    .then(onSuccess)
    .catch(onError);
}

function deleteUrl(baseUrl, url) {
  return axios.delete(`${baseUrl}${url}`).then(onSuccess).catch(onError);
}

export function getQueueData(customQueueId) {
  configureHttpHeaders(axios);
  return getUnmatched(`api/v2/queuemanager/getsubqueuelist?customQueueId=${customQueueId}`);
}

export const urlMapping = {
  // createQueue
  cq_mcc: 'api/v2/queuemanager/queue/mcc',
  cq_label: 'api/v2/queuemanager/queue/category',
  cq_portfolio: 'api/v2/queuemanager/queue/acquirercode',
  cq_pend_indicator: 'api/v2/queuemanager/queue/pendindicator',
  cq_base_queue: 'api/v2/queuemanager/baseQueueCascade',

  //Productivity Report
  pr_acquirer_name: 'api/v2/queuemanager/queue/acquirercode',
};

export function fetchFilterValuesBasedOnElementId(elementId, acquirerAccessList) {
  configureHttpHeaders(axios);
  if (elementId === 'cq_base_queue') {
    return get(urlMapping[elementId] + `?acquirerCodes=${acquirerAccessList}`);
  } else {
    return get(urlMapping[elementId]);
  }
}

export function getSubQueueCount(customQueueIdList) {
  configureHttpHeaders(axios);
  return get(`api/v2/queuemanager/count?customQueueIdList=${customQueueIdList}`);
}

export function postLockImage(documentId) {
  configureHttpHeaders(axios);
  return post(`api/v2/queuemanager/image/${documentId}/lock`);
}

export function unlockImage(documentId) {
  configureHttpHeaders(axios);
  let url = `api/v2/queuemanager/image/unlock`;
  if (documentId) {
    url += `?documentId=${documentId}`;
  }
  return deleteUrl(QUEUE_MANAGER_DATA_API, url);
}

export function updateTimeForLockedImages(lockedImages) {
  configureHttpHeaders(axios);
  let data = {
    recentLockedImages: lockedImages,
  };
  return post(`api/v2/queuemanager/image/lock`, data);
}

export function getFilterValuesForUserReport(elementId, includeUserSpecific) {
  configureHttpHeaders(axios);
  if (elementId === 'acquirer_code') {
    return get(`api/v2/queuemanager/queue/acquirercode?includeUserSpecific=${includeUserSpecific}`);
  }
}

export function saveDefaultRegion(data) {
  configureHttpHeaders(axios);
  return put(`api/v2/queuemanager/queue/region`, data);
}

export default {
  getMyQueues,
  getCategoryLabels,
  getQueueLabels,
  getDefaultQueueList,
  getExceptionQueue,
  getRegionCodeHeaderData,
  unAssignCase,
  assignCase,
  bulkAssignment,
  getGroupCasesCount,
  assignCasesToGroup,
  postBookMarkCase,
  undoBookMarkCase,
  getBookMarkedCases,
  getAllQueueList,
  getQueueGroupList,
  postCreateQueueFilters,
  getQueueData,
  postUpdateQueueFilters,
  updateQueueVisibility,
  deleteSubQueue,
  getNextCasesOfSubQueue,
  fetchFilterValuesBasedOnElementId,
  getExcepionList,
  unLockGetNextCases,
  postLockImage,
  unlockImage,
  updateTimeForLockedImages,
  saveDefaultRegion,
};
